module Cfnc {
    "use strict"

    interface ICfncExternalContentAttributes extends ng.IAttributes {

    }

    interface ICfncExternalContent extends ng.IScope {
        src: string;
        append: boolean;
        userId: number;
    }

    class CfncExternalContent implements ng.IDirective {
        static directiveId: string = "cfncExternalContent";
        restrict: string = "EA";
        replace: boolean = false;
        template: string = "";
        scope: any = {
            src: "=",
            append: "="
        }

        constructor(private $http: ng.IHttpService, private $compile: ng.ICompileService) { }

        link = (scope: ICfncExternalContent, element: ng.IAugmentedJQuery, attrs: ICfncExternalContentAttributes) => {
            var append = scope.append || true;
            //scope.userId = 12345678;
            var getExternalContent = (url: string) => {
                this.$http.get(url).then(response => {
                    if (response.status == 200) {
                        if (append) {
                            element.html(response.data.toString());

                            this.$compile(element.contents())(scope.$parent);
                        }
                        else {
                            element.replaceWith(response.data.toString());
                        }
                    } else {
                        console.error("Error loading external content", response);
                    }
                });
            }

            scope.$watch("src", (newValue: string, oldValue: string) => {
                if (newValue != oldValue) {
                    if (newValue == null || newValue == "") {
                        element.html("");
                    }
                    else {
                        getExternalContent(newValue);
                    }
                }
            });

            if (scope.src) {
                getExternalContent(scope.src);
            }

        }


    }


    angular.module("app").directive(CfncExternalContent.directiveId, ["$http", "$compile", ($http: ng.IHttpService, $compile: ng.ICompileService) => new CfncExternalContent($http, $compile)]);
}